export const environment = {
    production: 'true',
    envName: 'euro',
    base: 'http://www.unieuro.edu.br',
    ceumaHost: 'https://www.unieuro.edu.br/novoportal',
    wpBaseUrl: 'https://www.unieuro.edu.br/euro-wordpress',
    //apiBaseUrl: 'http://localhost:8089/',
    apiBaseUrl: 'https://www.unieuro.edu.br',
    apiBaseKey: '25231f2bd30c3c3d490e1e9a03729f94',
    //apiBaseKey: '7r1p483ml0c4#',
    apiBasePath: '/vestibular-api',
    authPath:'https://www.extranet.ceuma.br',
    authBasePath: '/authentication-api',
    matrPath: 'https://www.unieuro.edu.br',
    //matrPath: 'http://localhost:8089',
    apiNotExtranet: 'http://www.unieuro.edu.br',
    recaptchaKey: '6LfI7aIUAAAAAF52dUXDLfsqjleq0kB-YHuhpbV-',
    analyticsKey: 'UA-47244799-1',
    checkoutKey: 'cd15694f775ae81cda5d336ec0948789',
    checkoutKeyPos: '93c5c81497dd2d2e6123d55dcdf366a4',
    baseHref: '/',
    // apiMatriPath: '/matricula-api'
    checkoutBasePath: '/checkout-api',
    loginContexto: 'EURO',
    validacaoDocumentosBasePath:'https://www.extranet.ceuma.br',
    // FLAGS
    flagPosGraduacao: 'false',
    flagPosGraduacao2ViaBoleto: 'false',
    flagRematricula: 'true',
    //Novos paths
    egressoPath: '/universidade/egressos',
    calendarioAcademicoPath: 'https://www.unieuro.edu.br/euro-wordpress/wp-content/uploads/2021/06/calendarioacademico20212.pdf',
    //calendarioAcademicoPath: 'https://www.unieuro.edu.br/euro-wordpress/wp-content/uploads/2021/01/CALENDÁRIO-UNIEURO-2021-1.pdf',
    calendarioAcademicoURLWP: 'https://www.unieuro.edu.br/euro-wordpress//wp-json/wp/v2/documentos?_embed=true&per_page=15&filter%5Bdocument_type%5D=calendario-academico',
    title: 'Centro Universitário Unieuro',
    rematriculaPath:'http://www.unieuro.edu.br/sitenovo/matricula/loginAluno.asp',
    centralDoContratantePath: 'https://www.unieuro.edu.br/AreaDoContratante/login',
    posGraduacaoPath: undefined,
    extensaoPath: 'http://www.unieuro.edu.br/sitenovo/extensao2/',
    bibliotecaPath: 'http://www.unieuro.edu.br/portal/biblioteca/',
    eadPath: undefined,
    renovacaoBibliotecaPath:'http://www.unieuro.edu.br/sitenovo/servicos/biblioteca/login.asp',
    validacaoDocumentosPath:'https://www.unieuro.edu.br/ValidacaoDocumentos/',
    facebookPath:'https://www.facebook.com/unieuronarede',
    twitterPath:'https://twitter.com/UNIEURO_OFICIAL',
    youtubePath:'https://www.youtube.com/channel/UCtV17kCGS6rCvnqFyUgl1vw',
    instagramPath:'https://www.instagram.com/unieuro_oficial/',
    loginPath: 'http://www.unieuro.edu.br/portal/login',
    emailVestibular: 'vestibular@unieuro.edu.br',
    conveniadosPath: undefined,
    //Variavel de habilitação de integração de declaração de veracidade do vestibular de medicina
    docmentoVeracidadeInfoMedic: false,
    /* Dados de pagamento */
    codigoServicoVestibular:4,
    codigoServicoMatricula:5,
    codigoSistemaVestibular:1,
    codigoSistemaMatricula:4,
    pathDeclaracao: 'https://www.unieuro.edu.br/euro-wordpress/wp-content/uploads/2020/05/Anexo-I-Edital-nº-20_-2020-Vestibular-Medicina.pdf',
    pathMatriculaDigital: 'https://www.unieuro.edu.br/matricula-digital/',
    codigoCategoriaBiblioteca: null
  };


